export class OrganizerSettingEntity {
  organizerEmail: string;
  hasAssistant: boolean;
  assistantType: number;
  assistantEmail: string;
  assistantName: string;
  defaultLocations: DefaultLocationEntity;
  defaultResourceType: string;
  defaultCategoryIds: string; 
  quickButtons: QuickButtonEntity[];
  recommendationScreen: boolean;
  capacityFilter: boolean;
  aiAssistant: boolean;
  // lastUpdated: string;
  tileConfiguration: TileConfigurationEntity;
  dateTimeFormat: DateTimeFormatEntity;
  firstDayOfWeek: number;
  dateFormat: string;
  timeFormat: string;
  dateSeparator: string;

  constructor(data?: Partial<OrganizerSettingEntity>) {
    this.organizerEmail = data?.organizerEmail ?? "";
    this.hasAssistant = data?.hasAssistant ?? false;
    this.assistantType = data?.assistantType ?? 0;
    this.assistantEmail = data?.assistantEmail ?? "";
    this.assistantName = data?.assistantName ?? "";
    this.defaultLocations = data?.defaultLocations ?? new DefaultLocationEntity();
    this.defaultResourceType = data?.defaultResourceType ?? "";
    this.defaultCategoryIds = data?.defaultCategoryIds ?? "";
    this.quickButtons = data?.quickButtons ?? [];
    this.recommendationScreen = data?.recommendationScreen ?? true;
    this.capacityFilter = data?.capacityFilter ?? false;
    this.aiAssistant = data?.aiAssistant ?? false;
    // this.lastUpdated = data?.lastUpdated || "";
    this.tileConfiguration = data?.tileConfiguration ?? new TileConfigurationEntity();
    this.dateTimeFormat = data?.dateTimeFormat ?? new DateTimeFormatEntity();
    this.firstDayOfWeek = data?.firstDayOfWeek ?? 0;
    this.dateFormat = data?.dateFormat ?? "";
    this.timeFormat = data?.timeFormat ?? "";
    this.dateSeparator = data?.dateSeparator ?? "";
  }
}

// Default Resource Type

export class DefaultResourceTypeEntity {
  type: string;
  locationIds: string;
  displayName?: string;

  constructor(data?: Partial<DefaultResourceTypeEntity>) {
    this.type = data?.type ?? "";
    this.locationIds = data?.locationIds ?? "";
    this.displayName = data?.displayName ?? "";
  }
}

// Default Location

export class DefaultLocationEntity {
  defaultLocationIds: string;
  defaultResourceTypes: DefaultResourceTypeEntity[];

  constructor(data?: Partial<DefaultLocationEntity>) {
    this.defaultLocationIds = data?.defaultLocationIds ?? "";
    this.defaultResourceTypes = data?.defaultResourceTypes ?? [];
  }
}

// Quick Button

export class QuickButtonEntity {
  id: number;
  name: string;
  tooltip: string;
  type: string;
  data: { name: string; email: string }[];
  orderIndex: number;
  locations: string;

  constructor(data?: Partial<QuickButtonEntity>) {
    this.id = data?.id ?? 0;
    this.name = data?.name ?? "";
    this.tooltip = data?.tooltip ?? "";
    this.type = data?.type ?? "";
    this.data = data?.data ?? [];
    this.orderIndex = data?.orderIndex ?? 0;
    this.locations = data?.locations ?? "";
  }
}

// Tile Configuration

export class TileConfigurationEntity {
  resourceType: boolean;
  location: boolean;
  capacity: boolean;
  category: boolean;
  timeline: boolean;

  constructor(data?: Partial<TileConfigurationEntity>) {
    this.resourceType = data?.resourceType ?? true;
    this.location = data?.location ?? true;
    this.capacity = data?.capacity ?? true;
    this.category = data?.category ?? true;
    this.timeline = data?.timeline ?? true;
  }
}


// Date Time Format
export class DateTimeFormatEntity {
  firstDayOfWeek: number;
  dateFormat: string;
  timeFormat: string;
  dateSeparator: string;

  constructor(data?: Partial<DateTimeFormatEntity>) {
    this.firstDayOfWeek = data?.firstDayOfWeek ?? 0;
    this.dateFormat = data?.dateFormat ?? "DD-MM-YYYY";
    this.timeFormat = data?.timeFormat ?? "HH:mm";
    this.dateSeparator = data?.dateSeparator ?? "";
  }
}